<template lang="html">

  <section class="common">
    <h1>common Component</h1>
  </section>

</template>

<script lang="js">

import companyConfig from '@/company_config.json'

  export default  {
    name: 'common',
    props: [],
    mounted () {

    },
    data () {
      return {

      }
    },
    methods: {
      test(){
        // alert('test');
        console.log('test function is called');
      },
      pageRedirect(params, url){
        console.log('pageRedirect function is called');
        console.log('url='+url+', params='+JSON.stringify(params));
        var n1= Object.keys(params).length;
        console.log('n1='+n1);
        // this.pageLoadingOn();
        if (n1 > 0) {
          this.$router.push({
            path: url,
            query: params,
          });
        } else {
          if (url != "") {
            this.$router.push(url);            
          } else {
            this.$router.go();
          }          
        }
        // this.pageLoadingOff();
      },
      successMessage(message){
        this.$vs.notify({ title:'Success', text: message, color:'success', iconPack: 'feather', icon:'icon-check', position: 'top-center' } );
      },
      errorMessage(message){
        this.$vs.notify({ title:'Failed', text: message, color:'warning', iconPack: 'feather', icon:'icon-alert-circle', position: 'top-center' } );
      },
      pageLoadingOn(){
        this.$vs.loading({ type:'material', });
      },
      pageLoadingOff(){
        this.$vs.loading.close();
      },
      selectListActiveStatus(){
        var result = [
          { value: '', text: '--Select Status--' },
          { value: "0", text: 'InActive' },
          { value: "1", text: 'Active' },
        ];
        return result;
      },
      selectListCreditDebit(){
        var result = [
          { value: '', text: '--Select Type--' },
          { value: '1', text: 'Credit' },
          { value: '2', text: 'Debit' },
        ];
        return result;
      },
      selectListPaymentType(){
        var result = [
          { value: '', text: '--Select Type--' },
          { value: 1, text: 'Cash' },
          { value: 2, text: 'Bank' },
          { value: 3, text: 'Wallet' },
        ];
        return result;
      },
      selectListTrueFalse(){
        var result = [
          { value: '', text: '--Select--' },
          { value: 1, text: 'Yes' },
          { value: 2, text: 'No' },
        ];
        return result;
      },
      selectListYesNo(){
        var result = [
          { value: '', text: '--Select--' },
          { value: "0", text: 'No' },
          { value: "1", text: 'Yes' },
        ];
        return result;
      },
      selectListPartyCategory(){
        var result = [
          { value: '', text: '--Select Category--' },
          { value: 1, text: 'Supplier' },
          { value: 2, text: 'Customer' },
          { value: 3, text: 'Employees' },
        ];
        return result;
      },
      // Used in LocalCessTypeAddNew, 
      selectListCessCalculationMethod(){
        var result = [
          { value: '', text: '--Select Type--' },
          { value: 1, text: 'Add Before Subtotal' },
          { value: 2, text: 'Add After Subtotal' },
        ];
        return result;
      },
      selectListFinancialYear(){
        var result = [
          { value: '', text: '--Select--' },
          { value: '2019-2020', text: '2019-2020' },
          { value: '2020-2021', text: '2020-2021' },
          { value: '2021-2022', text: '2021-2022' },
          { value: '2022-2023', text: '2022-2023' },
        ];
        return result;
      },
      onlyNumber ($event) {
        console.log($event.keyCode); //keyCodes value
        let keyCode = ($event.keyCode ? $event.keyCode : $event.which);
        if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) { // 46 is dot
            $event.preventDefault();
        }
      },      
      logout() {

        console.log('logout function is called from common vue');

        // this.$vs.loading({ type:'material', });
        
        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        var url=server_url+'lib/logout';
        console.log('url='+url);

        const token=this.$session.get('token');
        console.log('token='+token);
        
        var upload = {
          'token': token,
        };
        console.log('upload='+JSON.stringify(upload));

        this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(function (response) {
            // this.$vs.loading.close();
            console.log('response='+JSON.stringify(response));                
        })
        .catch(function (error) {
            console.log('error='+error);
        })
        console.log('now you are going to logout');
        this.$session.destroy();
        this.$router.push('/');
      },

      addDataListData(formData, url, destination, list_url){
        
        console.log('addDataListData function is called');
        console.log('formData='+JSON.stringify(formData)+', url='+url+', list_url='+list_url);

        var n1= formData.length;
        console.log('n1='+n1);

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);
        
        const token=this.$session.get('token');
        console.log('token='+token);
        
        // var result = {};
        
        if (n1 > 0 ) {

          const thisIns = this;

          var form ={};
          for (var index = 0; index < n1; index++) {
            var element = formData[index];
            console.log('index='+index+', element='+element);
            var formValue = thisIns[element];
            console.log('formValue='+formValue);            
            form[element] = formValue;            
          }
          var n2= Object.keys(form).length;
          console.log('n2='+n2);          
          console.log('form='+JSON.stringify(form));

          var upload = {
            'token': token,
            'form': form
          };
          
          thisIns.pageLoadingOn();
                    
          var output="";
          var successTxt="";
          var errorTxt="";
          var flag=0;

          this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            flag = response.data.flag;            
            console.log('output='+output+', flag='+flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
            
            thisIns.pageLoadingOff();
            if (flag == 1) {
              thisIns.successMessage(successTxt);
              if (destination != '' && list_url != '') {                
                // console.log('destination='+destination+', list_url='+list_url);
                thisIns.pageRedirect('', list_url);
                // thisIns.getTableData(destination, list_url);
              }

            }else{
              thisIns.errorMessage(errorTxt);
            }

          })
          .catch(function (error) {
            console.log('error='+error);
          })
          
        }
        
      },
      getSelectBoxOptions(source, destination, condition,  url) {

        console.log('getSelectBoxOptions function is called');

        console.log('source='+source+', destination='+destination+', condition='+JSON.stringify(condition)+', url='+url);        

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);

        const token=this.$session.get('token');
        console.log('token='+token);

        this.pageLoadingOn();
        
        const thisIns = this;
        var output="";
        var flag=0;
        var records=[];
        var totalRecords=0;

        var sourceValue = thisIns[source];
        console.log('sourceValue='+sourceValue);
        /*
        var additional = {};
        var n1=condition.length;
        console.log('n1='+n1);
        for (let index = 0; index < n1; index++) {
          var element = condition[index];
          var temp = thisIns[element];
          console.log('index='+index+', element='+element+', temp='+temp);
          if (temp != '') {
            additional[element]=temp;
          }
        }
        console.log('additional='+JSON.stringify(additional));
        */
        var upload = {
          'token': token,
          'source': sourceValue,
          'additional': condition,
        };
        console.log('upload='+JSON.stringify(upload));
        /*
        var conditionValue = condition == '' ?  '' : thisIns[condition];
        console.log('conditionValue='+conditionValue);
        */
        this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded'
            }
        })
        .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;      
            totalRecords= records.length;
            console.log('output='+output+', flag='+flag+', totalRecords='+totalRecords);
            thisIns.pageLoadingOff();
            if (flag == 1) {
                records = response.data.records;
                thisIns[destination]=records;
            }else{
                thisIns.errorMessage(output);
            }
        })
        .catch(function (error) {
            console.log('error='+error);
        })
          
      },
      getTableData(rows, url, where) {

        console.log('getTableData function is called');

        console.log('rows='+rows+', url='+url+', where='+JSON.stringify(where));

        this.pageLoadingOn();
        
        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);

        const token=this.$session.get('token');
        console.log('token='+token);

        if (token == "") {
          this.logout();
        }
        
        const thisIns = this;
        var output="";
        var successTxt="";
        var errorTxt="";
        var flag=0;
        var records=[];
        var totalRecords=0;
        
        var upload = {
          'token' : token,
          'where' : where
        };

        console.log('upload='+JSON.stringify(upload));
        
        this.$http({
          url: url,
          method: 'POST',
          data: upload,
          headers: {
            'Content-Type': 'application/x-www-form-urlencoded'
          }
        })
        .then(function (response) {
          console.log('response='+JSON.stringify(response));
          output = response.data.output;
          flag = response.data.flag;
          successTxt = response.data.success;
          errorTxt = response.data.error;
          console.log('output='+output+', flag='+flag);
          console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
          thisIns.pageLoadingOff();
          if (flag == 1) {
            records = response.data.records;
            totalRecords= records.length;
            console.log('totalRecords='+totalRecords);
            thisIns[rows]=records;
            // thisIns.$parent[rows]=records;
            // thisIns.successMessage(successTxt);
            
          }else{
            // thisIns.message=output
            // thisIns.errorMessage(errorTxt);
          }
        })
        .catch(function (error) {
          console.log('error='+error);
        })
        
      },
      addRecords(formData, url, redirect_url){
        
        console.log('addRecords function is called');
        console.log('formData='+JSON.stringify(formData)+', url='+url+', redirect_url='+redirect_url);

        var n1= formData.length;
        console.log('n1='+n1);

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);
        
        const token=this.$session.get('token');
        console.log('token='+token);
        
        // var result = {};
        
        if (n1 > 0 ) {

          const thisIns = this;

          var form ={};
          for (var index = 0; index < n1; index++) {
            var element = formData[index];
            console.log('index='+index+', element='+element);
            var formValue = thisIns[element];
            console.log('formValue='+formValue);            
            form[element] = formValue;            
          }
          var n2= Object.keys(form).length;
          console.log('n2='+n2);          
          console.log('form='+JSON.stringify(form));

          var upload = {
            'token': token,
            'form': form
          };
          
          thisIns.pageLoadingOn();
                    
          var output="";
          var successTxt="";
          var errorTxt="";
          var flag=0;

          this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            flag = response.data.flag;            
            console.log('output='+output+', flag='+flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
            
            thisIns.pageLoadingOff();
            if (flag == 1) {

              for (var index = 0; index < n1; index++) {
                var element = formData[index];
                console.log('index='+index+', element='+element);
                // thisIns[element]='';
              }              
              thisIns.successMessage(successTxt);
              var params = {};
              thisIns.pageRedirect(params, redirect_url);

            }else{
              thisIns.errorMessage(errorTxt);
            }

          })
          .catch(function (error) {
            console.log('error='+error);
          })
          
        }
        
      },      
      getRecords(where, destinations, url){

        console.log('getRecords function is called');
        console.log('where='+JSON.stringify(where)+', destinations='+JSON.stringify(destinations)+', url='+url);

        var n1= Object.keys(where).length;
        var n2= destinations.length;
        console.log('n1='+n1+', n2='+n2);

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);
        
        const token=this.$session.get('token');
        console.log('token='+token);

        if (!this.$session.exists()) {
          console.log('your session is expired');
          this.$router.push('/logout');
        }
        // var result = {};

        if (n1 > 0) {

          this.pageLoadingOn();
          var output="";
          var successTxt="";
          var errorTxt="";
          var flag=0;
          
          const thisIns = this;
          
          var records=[];
          var totalRecords=0;

          var upload = {
            'token': token,
            'where': where
          };
          
          console.log('upload='+JSON.stringify(upload));
          
          this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;        
            console.log('output='+output+', flag='+flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
            
            thisIns.pageLoadingOff();
            if (flag == 1) {

              records = response.data.records[0];
              // totalRecords= records.length;
              console.log('totalRecords='+totalRecords);
              console.log('records='+JSON.stringify(records));
              for (var index = 0; index < n2; index++) {

                var element = destinations[index];
                console.log('index='+index+', element='+element);

                var result = records[element];
                console.log('result='+result);                
                
                var search=records.hasOwnProperty(element);
                console.log('search='+search);
                
                if (search) {
                  thisIns[element] = result;
                }
                
              }
              thisIns.successMessage(successTxt);

            }else{
              thisIns.errorMessage(errorTxt);
            }

          })
          .catch(function (error) {
            console.log('error='+error);
          })
          
        }
        
      },
      updateRecords(where, formData, url, redirect_url, params){
        
        console.log('updateRecords function is called');
        console.log('where='+JSON.stringify(where)+', formData='+JSON.stringify(formData)+', url='+url+', params='+JSON.stringify(params)+', redirect_url='+redirect_url);

        var n1= Object.keys(where).length;
        var n2= formData.length;
        console.log('n1='+n1+', n2='+n2);

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);
        
        const token=this.$session.get('token');
        console.log('token='+token);
        
        // var result = {};

        if (n1 > 0 && n2 > 0) {
          
          var form ={};
          for (var index = 0; index < n2; index++) {
            var element = formData[index];
            console.log('index='+index+', element='+element);
            var formValue = this[element];
            console.log('formValue='+formValue);            
            form[element] = formValue;            
          }
          var n3= Object.keys(form).length;
          console.log('n3='+n3);          
          console.log('form='+JSON.stringify(form));

          this.pageLoadingOn();
          var upload = {
            'token': token,
            'where': where,
            'form': form
          };
          
          console.log('upload='+JSON.stringify(upload));
          
          const thisIns = this;
          var output="";
          var successTxt="";
          var errorTxt="";
          var flag=0;

          this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            flag = response.data.flag;            
            console.log('output='+output+', flag='+flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
            
            thisIns.pageLoadingOff();
            if (flag == 1) {

              thisIns.successMessage(successTxt);              
              thisIns.pageRedirect(params, redirect_url);

            }else{
              thisIns.errorMessage(errorTxt);
            }

          })
          .catch(function (error) {
            console.log('error='+error);
          })
          
        }
        
      },
      deleteRecords(delete_where, url, destination, list_url, list_where){
        
        console.log('deleteRecords function is called');
        console.log('delete_where='+JSON.stringify(delete_where)+', url='+url+', destination'+destination+', list_url='+list_url+', list_where='+JSON.stringify(list_where));

        var n1= Object.keys(delete_where).length;
        console.log('n1='+n1);

        var n2= Object.keys(list_where).length;
        console.log('n2='+n2);

        var server_url=companyConfig.apiURL;
        console.log('server_url='+server_url);

        url=server_url+url;
        console.log('url='+url);
        
        const token=this.$session.get('token');
        console.log('token='+token);        
        
        // var result = {};
        
        if (n1 > 0) {

          var upload = {
            'token': token,
            'where': delete_where
          };
          
          console.log('upload='+JSON.stringify(upload));
                    
          
          this.pageLoadingOn();
          const thisIns = this;
          var output="";
          var successTxt="";
          var errorTxt="";
          var flag=0;

          this.$http({
            url: url,
            method: 'POST',
            data: upload,
            headers: {
              'Content-Type': 'application/x-www-form-urlencoded'
            }
          })
          .then(function (response) {
            console.log('response='+JSON.stringify(response));
            output = response.data.output;
            flag = response.data.flag;
            output = response.data.output;
            flag = response.data.flag;            
            console.log('output='+output+', flag='+flag);
            successTxt = response.data.success;
            errorTxt = response.data.error;
            console.log('successTxt='+successTxt+', errorTxt='+errorTxt);
            
            thisIns.pageLoadingOff();
            if (flag == 1) {
              thisIns.successMessage(successTxt);
              if (destination!= '' && list_url != '') {
                // thisIns.pageRedirect('', list_url);
                thisIns.getTableData(destination, list_url, list_where);
              }
            }else{
              thisIns.errorMessage(errorTxt);
            }

          })
          .catch(function (error) {
            console.log('error='+error);
          })
          
        }
        
      },
      calculateCessAmount(cessRules, productId, Qty, amount){

        console.log('calculateCessAmount called');
        console.log('cessRules='+JSON.stringify(cessRules)+', productId='+productId+', Qty='+Qty+', amount='+amount);
        // Calculate CESS Amount used in Sales Create
        var cess=0;
        /*
        // Find the CESS Rule Index by the product id
        var idx = cessRules.map(e => e.CessRulesProductId).indexOf(productId);
        console.log('productId='+productId+', idx='+idx);
        */
        var tempProducts = cessRules.filter(function(product) {
          return product.CessRulesProductId == productId;
        });
        var n1=tempProducts.length;
        console.log('n1='+n1+', tempProducts='+JSON.stringify(tempProducts));

        // If any records found CESS will be calculate otherwise, CESS will be return as 0
        if (n1 == 1) {

          // The CESS Rule record
          console.log('cessRules='+JSON.stringify(tempProducts[0]));

          // Get the values from records
          var cessPercentage=tempProducts[0]['CessRulesPercentage'];
          var perQty=tempProducts[0]['CessRulesPerQty'];
          var fixedValue=tempProducts[0]['CessRulesFixedValue'];
          var highestFlag=tempProducts[0]['CessRulesHighestFlag'];
          console.log('cessPercentage='+cessPercentage+', perQty='+perQty+', fixedValue='+fixedValue+', highestFlag='+highestFlag);

          // Calculate total by Percentage
          var cessTotalPercentage=parseFloat(amount) * (parseFloat(cessPercentage) / 100);
          cessTotalPercentage = isNaN(cessTotalPercentage) ? 0 : cessTotalPercentage;

          // Calculate total by Fixed amount per Qty
          var cessTotalFixedAmount=parseFloat(fixedValue) * (parseFloat(Qty) / parseFloat(perQty));
          cessTotalFixedAmount = isNaN(cessTotalFixedAmount) ? 0 : cessTotalFixedAmount;

          // Sum of Percentage Total and Fixed amount per Qty Total
          var cessTotal=cessTotalPercentage+cessTotalFixedAmount;

          // Find the Highest value from Percentage Total and Fixed amount per Qty Total
          var cessHighest=cessTotalPercentage > cessTotalFixedAmount ? cessTotalPercentage : cessTotalFixedAmount;
          console.log('cessTotalPercentage='+cessTotalPercentage+', cessTotalFixedAmount='+cessTotalFixedAmount+', cessTotal='+cessTotal+', cessHighest='+cessHighest);

          // If Highest value = 1, Highest value will return, else Sum of Total will be return
          cess = highestFlag == 1 ? cessHighest : cessTotal;
          // cess=5.6;
          // cess=Math.round(cess).toFixed(2);
          cess=parseFloat(cess).toFixed(2);
          console.log('cess='+cess);
        }
        return cess;
      },
      calculateLocalCessAmount(localCessRules, cessTypeId, productId, Qty, amount){

        console.log('calculateLocalCessAmount called');
        console.log('localCessRules='+JSON.stringify(localCessRules)+', cessTypeId='+cessTypeId+'productId='+productId+', Qty='+Qty+', amount='+amount);
        // Calculate CESS Amount used in Sales Create
        var cess=0;
        /*
        // Find the CESS Rule Index by the product id
        var idx = cessRules.map(e => e.CessRulesProductId).indexOf(productId);
        console.log('productId='+productId+', idx='+idx);
        */
        var tempProducts = localCessRules.filter(function(product) {
          return product.ProductId == productId && product.LocalCessTypeId == cessTypeId;
        });
        var n1=tempProducts.length;
        console.log('n1='+n1+', tempProducts='+JSON.stringify(tempProducts));

        // If any records found CESS will be calculate otherwise, CESS will be return as 0
        if (n1 == 1) {

          // The CESS Rule record
          console.log('cessRules='+JSON.stringify(tempProducts[0]));

          // Get the values from records
          var cessPercentage=tempProducts[0]['ProductPercentage'];
          var perQty=tempProducts[0]['ProductQty'];
          var fixedValue=tempProducts[0]['ProductFixedValue'];
          var highestFlag=tempProducts[0]['RulesHighestFlag'];
          console.log('cessPercentage='+cessPercentage+', perQty='+perQty+', fixedValue='+fixedValue+', highestFlag='+highestFlag);

          // Calculate total by Percentage
          var cessTotalPercentage=parseFloat(amount) * (parseFloat(cessPercentage) / 100);
          cessTotalPercentage = isNaN(cessTotalPercentage) ? 0 : cessTotalPercentage;

          // Calculate total by Fixed amount per Qty
          var cessTotalFixedAmount=parseFloat(fixedValue) * (parseFloat(Qty) / parseFloat(perQty));
          cessTotalFixedAmount = isNaN(cessTotalFixedAmount) ? 0 : cessTotalFixedAmount;

          // Sum of Percentage Total and Fixed amount per Qty Total
          var cessTotal=cessTotalPercentage+cessTotalFixedAmount;

          // Find the Highest value from Percentage Total and Fixed amount per Qty Total
          var cessHighest=cessTotalPercentage > cessTotalFixedAmount ? cessTotalPercentage : cessTotalFixedAmount;
          console.log('cessTotalPercentage='+cessTotalPercentage+', cessTotalFixedAmount='+cessTotalFixedAmount+', cessTotal='+cessTotal+', cessHighest='+cessHighest);

          // If Highest value = 1, Highest value will return, else Sum of Total will be return
          cess = highestFlag == 1 ? cessHighest : cessTotal;
          // cess=5.6;
          // cess=Math.round(cess).toFixed(2);
          cess=parseFloat(cess).toFixed(2);
          console.log('cess='+cess);
        }
        return cess;
      },      
      generatePDF(filename, pdfType, windowType, docDefinition){
        var pdfMake = require('pdfmake/build/pdfmake.js');
        if (pdfMake.vfs == undefined){
            var pdfFonts = require('pdfmake/build/vfs_fonts.js');
            pdfMake.vfs = pdfFonts.pdfMake.vfs;
        }
        // windowType: 1=Same window, 2=New window
          var win = windowType == 1 ? window : window.open('', '_blank');
        // pdfType: 1=Download, 2=Open, 3=Print

        if (pdfType == 1) {
          pdfMake.createPdf(docDefinition).download(filename+'.pdf');
        } else if (pdfType == 2) {
          pdfMake.createPdf(docDefinition).open({}, win);
        } else if (pdfType == 3) {
          pdfMake.createPdf(docDefinition).print({}, win);
        } else {
          var safari = navigator.userAgent.indexOf("Safari");
          console.log('safari='+safari);
          if (safari != -1) {
              pdfMake.createPdf(docDefinition).open({}, window.frames['printPdf']);
              setTimeout(function() {
                  window.frames['printPdf'].focus();
                  window.frames['printPdf'].print();
              }, 2000)
          } else {
              pdfMake.createPdf(docDefinition).print({}, window.frames['printPdf']);
          }
          // pdfMake.createPdf(docDefinition).open({}, window);
        }
        
      }
    },
    computed: {

    }
}


</script>

<style scoped lang="scss">
  .common {

  }
</style>
